const decimalFormatter = function decimalFormatterHelper(stringWithDecimal) {
  const emptyDecimals = new RegExp(/\.00/);
  const removeDecimal = emptyDecimals.test(stringWithDecimal);

  return removeDecimal ? stringWithDecimal.replace(emptyDecimals, '') : stringWithDecimal;
};

export default decimalFormatter;
